import React from 'react';
import google_play_svg from '../../../assets/images/banners/google-play.svg';
import app_store_svg from '../../../assets/images/banners/app-store.svg';
import I18n from '../../../blocks/localization';
import { APP_STORE_URL, GOOGLE_PLAY_URL } from '../../../config';

const BannerMobileApplication = () => (
    <div className="psmobapp_ban">
        <h4 className="title">{I18n.t('banners.mobileApplicationTitle')}</h4>
        <p>{I18n.t('banners.mobileApplicationText')}</p>
        <a href={GOOGLE_PLAY_URL} target="_blank" className="btn_link"><img src={google_play_svg} alt="Google Play" /></a>
        <a href={APP_STORE_URL} target="_blank" className="btn_link"><img src={app_store_svg} alt="Apple Store" /></a>
    </div>
);

export default BannerMobileApplication;
